module.exports = __webpack_public_path__ + "img/parallax3-1440p.be48840b.jpg";